import * as React from 'react'
import { IActiveTripResponseV2, IRiderTrip } from '../../../types'
import { metersToMiles, secondsToMinutes, convertCentsToDollars } from '../../../utils'
import ImageTripCompleted from '../../ui/ImageTripCompleted'
import FormatCarPlate from '../../ui/FormatCarPlate'
import UIMessages from '../../../utils/ui-messages'
import { mapViewStrategyStages } from '../../MapView'
import { tripService } from '../../../services/Trip'
import { priceValueMask } from '../../../utils/mask'
import EditTripModal from 'src/containers/trips/EditTripModal'
import { Route } from 'react-router'
import { Link } from 'react-router-dom'
import Edit from 'src/components/icons/ui/Edit'
import ContextMenu from 'src/components/ui/ContextMenu'
import { ITripGroupRides } from 'src/types/trip-group-rides'
import TripPaymentDisplay from './TripRiderDetails'
interface ITripCompletedProps {
  uberItegrationIds: string[]
  currentTrip: IActiveTripResponseV2
  setCurrentTripStage: (stage: string) => void
}

interface ITripCompletedState {
  providerPrice: number
  servicePrice: number
  amountCharged: number
  promotionId: string | null
  totalTripAddOns: number
}

class TripCompleted extends React.Component<ITripCompletedProps, ITripCompletedState> {
  constructor(props: ITripCompletedProps) {
    super(props)
    this.EditDetails = this.EditDetails.bind(this)
    this.state = {
      providerPrice: 0,
      servicePrice: 0,
      amountCharged: 0,
      promotionId: null,
      totalTripAddOns: 0
    }
  }
  public componentDidMount() {
    this.fetchReceipt()
    this.props.setCurrentTripStage(mapViewStrategyStages.showPolyline)
  }

  public render() {
    const trip = this.props.currentTrip
    const { totalTripAddOns, providerPrice, servicePrice, amountCharged, promotionId } = this.state

    if (!trip) {
      return null
    }

    const duration = trip.duration ? secondsToMinutes(trip.duration) : 'Unavailable'
    const distance = trip.distance ? `${metersToMiles(trip.distance)} miles` : 'Unavailable'
    const estimatedDuration = trip.estimatedDuration ? secondsToMinutes(trip.estimatedDuration) : 'Unavailable'
    const estimatedDistance = trip.estimatedDistance ? `${metersToMiles(trip.estimatedDistance)} miles` : 'Unavailable'
    const estimatedLoadingTime = trip.product.estimatedLoadingTime
      ? `${trip.product.estimatedLoadingTime} mins`
      : 'Unavailable'
    const operatorName = trip.operator ? `${trip.operator.firstName} ${trip.operator.lastName}` : 'No operator assigned'
    const operatorPhone = trip.operator ? trip.operator.phone : ''

    const providerPriceText = `$${convertCentsToDollars(trip.estimatedPrice)}` // Total amount of the cash and noncash riders fare regardless of fare type
    const servicePriceText = `$${convertCentsToDollars(trip.estimatedFare)}` // Total amount of the cash and noncash riders price regardless of fare type
    const discountText = promotionId ? `$${convertCentsToDollars(servicePrice - amountCharged)}` : '0.00'
    const fareText = `$${convertCentsToDollars(amountCharged)}`
    const totalTripAddOnsText = `$${convertCentsToDollars(totalTripAddOns)}`
    const paymentMode = trip.paymentMode ? trip.paymentMode : 'Cash'
    // const paymentMode =
    //   trip.tripsGroupRides[0] && trip.tripsGroupRides[0].fareType ? trip.tripsGroupRides[0].fareType : 'Wallet'

    const vehiclePlate = trip.vehicle ? trip.vehicle.licensePlate : ''
    const vehicleModel = trip.vehicle ? trip.vehicle.model : ''
    const vehicleMake = trip.vehicle ? trip.vehicle.make : ''
    const showUBERHelpLink = trip.product.integrationId
      ? this.props.uberItegrationIds.includes(trip.product.integrationId)
      : false

    const addOnKeyId = `${trip.service.name}-${trip.product.name}-add-on-key`.split(' ').join('_')

    return (
      <React.Fragment>
        <Route exact={true} path={`/trips/${trip.id}/edit-details`} render={this.EditDetails} />
        <div className='px2 py2'>
          <div className='flex '>
            {/* Bottom Details for Avatar */}
            <div className={trip.operator ? 'pr1' : ''}>
              <ImageTripCompleted
                name={operatorName}
                entityId={trip.operator ? trip.operator.id : ''}
                width='40px'
                height='40px'
                isRounded={true}
                fgcolor={'#FFFFFF'}
              />
            </div>
            {/* Bottom Details for Avatar*/}
            <div className='col-12 content-center'>
              <div className='flex'>
                <p className='m0 font-black h5'>{operatorName}</p>
              </div>
              <div className='h6 font-grey2'>
                {trip.service.name} {trip.product.name}
              </div>
            </div>
            <div className='pl2 content-center'>
              <ContextMenu>
                <Link to={`/trips/${trip.id}/edit-details`}>
                  <Edit className='icon--small svg-stroke-grey3 mr1' />
                  <span className='font-dark-grey'>{UIMessages.common.editDetails}</span>
                </Link>
              </ContextMenu>
            </div>
          </div>
          <div className='h6 font-grey2 mt1'>
            <span className='h6 font-black'>Notes:</span>
            {trip.notes}
          </div>
          {trip.vehicle ? (
            <div className='h5 col-12 font-grey2 content-center'>
              <span className='h5'>
                {vehicleModel} {vehicleMake}
              </span>
              <FormatCarPlate plate={vehiclePlate} />
            </div>
          ) : null}

          <div className='flex flex-column h5 col-12'>
            <div className='flex justify-between mt1'>
              <div className='flex col-5 justify-between'>
                <p className='m0 h5 font-black'>{UIMessages.common.riders}:</p>
                <p className='m0 h5 font-black'>{this.props.currentTrip.riderCount}</p>
              </div>
            </div>
            <div className='flex justify-between mt1'>
              <div className='flex col-5 justify-between'>
                <p className='m0 h5 font-black'>Price:</p>
                <p className='m0 h5 font-black'> {priceValueMask(providerPriceText)}</p>
              </div>
              <div className='flex col-5 justify-between'>
                <p className='m0 h5 font-black'>Fare:</p>
                <p className='m0 h5 font-black'> {priceValueMask(servicePriceText)}</p>
              </div>
            </div>
            <div className='flex justify-between mt1'>
              <div className='flex col-5 justify-between'>
                <p className='m0 h5 font-black'>AddOn:</p>
                <p className='m0 h5 font-black'>{priceValueMask(totalTripAddOnsText)}</p>
              </div>
              <div className='flex col-5 justify-between'>
                <p className='m0 h5 font-black'>Discount:</p>
                <p className='m0 h5 font-black'>{priceValueMask(discountText)}</p>
              </div>
            </div>
          </div>

          {trip.addOn && (
            <div>
              {Object.keys(trip.addOn).map(key => {
                return (
                  <div className='flex col-12 justify-start' id={addOnKeyId} key={key}>
                    <label className='font-grey2 h6 weight-300 ml2'>
                      {key} ${trip.addOn && (trip.addOn[key] / 100).toFixed(2)}
                    </label>
                  </div>
                )
              })}
            </div>
          )}
          <div className='flex flex-column h5'>
            <div className='flex justify-between mt1'>
              <div className='flex col-12 justify-between'>
                <p className='m0 h5 font-black'>Amount Charged:</p>
                <p className='m0 h5 font-black'> {priceValueMask(fareText)}</p>
              </div>
            </div>
          </div>

          <TripPaymentDisplay
            tripsGroupRides={trip.tripsGroupRides}
            paymentMode={paymentMode}
            serviceId={trip.service.serviceId}
            tripId={trip.id}
          />

          <div className='flex flex-column h5'>
            <div className='flex justify-between mt1'>
              <div className='flex col-12 justify-between'>
                <p className='m0 h5 font-black'>Estimated Duration:</p>
                <p className='m0 h5 font-black'>{estimatedDuration}</p>
              </div>
            </div>
            <div className='flex justify-between mt1'>
              <div className='flex col-12 justify-between'>
                <p className='m0 h5 font-black'>Estimated Distance:</p>
                <p className='m0 h5 font-black'>{estimatedDistance}</p>
              </div>
            </div>
            <div className='flex justify-between mt1'>
              <div className='flex col-12 justify-between'>
                <p className='m0 h5 font-black'>Duration:</p>
                <p className='m0 h5 font-black'>{duration}</p>
              </div>
            </div>
            <div className='flex justify-between mt1'>
              <div className='flex col-12 justify-between'>
                <p className='m0 h5 font-black'>Distance:</p>
                <p className='m0 h5 font-black'>{distance}</p>
              </div>
            </div>
            <div className='flex justify-between mt1'>
              <div className='flex col-12 justify-between'>
                <p className='m0 h5 font-black'>Est. Loading/Unloading Time:</p>
                <p className='m0 h5 font-black'>{estimatedLoadingTime}</p>
              </div>
            </div>
          </div>

          {showUBERHelpLink && (
            <button className='SubmitButton btn bg-green rounded font-white weight-300' onClick={this.openUBERurl}>
              UBER customer support
            </button>
          )}
        </div>
      </React.Fragment>
    )
  }

  private async fetchReceipt() {
    try {
      const receipts = await tripService.receipts(this.props.currentTrip.id)
      const receipt = receipts.pop()
      this.setState({
        providerPrice: receipt.providerPrice,
        servicePrice: receipt.servicePrice,
        promotionId: receipt.appliedPromotionsId,
        amountCharged: receipt.amountCharged,
        totalTripAddOns: this.computeTripTotalAddons(this.props.currentTrip.addOn)
      })
    } catch (e) {
      console.log('receipt error: ', e)
    }
  }
  private EditDetails() {
    return <EditTripModal enableOtherFields={false} {...this.props} />
  }
  private openUBERurl() {
    const uberHelpURL =
      'https://help.uber.com/riders/article/contact-us-for-rider-support-?nodeId=81409131-19fd-4714-99d7-51c8ea97647c'
    window.open(uberHelpURL, '_blank')
  }

  private computeTripTotalAddons(addOn?: { [key: string]: number }) {
    let total: number = 0

    if (addOn) {
      Object.keys(addOn).map(key => {
        total = total + addOn[key]
      })
    }
    return total
  }
}

export default TripCompleted



// WEBPACK FOOTER //
// ./src/components/trips/trip-detail/TripCompleted.tsx